import { render } from "./PresentacionesView.vue?vue&type=template&id=3998e4a2&scoped=true"
import script from "./PresentacionesView.vue?vue&type=script&lang=js"
export * from "./PresentacionesView.vue?vue&type=script&lang=js"

import "./PresentacionesView.vue?vue&type=style&index=0&id=3998e4a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3998e4a2"]])

export default __exports__